import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@/AppQueryClient";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type {
  PatchUserNamesParams,
  UserWithAuthorizations,
} from "./apiEcms.types";

const patchUserNames = ({ id, lastName, firstName }: PatchUserNamesParams) =>
  apiEcmsHttp.patch<UserWithAuthorizations>(`/users/${id}/names`, {
    firstName,
    lastName,
  });

export const usePatchUserNames = () => {
  const { currentGroup } = useGroupReferences();

  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationFn: patchUserNames,
    retry: false,
    mutationKey: [QUERY_KEYS.USERNAME_EDITION, currentGroup],
    onSuccess: ({ data: user }) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USER, user.id, currentGroup],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USERS, currentGroup],
      });
      addToast({
        variant: "success",
        title: t("userDetails.informations.updateUserIdentitySuccess"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("userDetails.informations.updateUserIdentityError"),
      });
    },
  });
};
